module.exports = __webpack_public_path__ + "media/images/sarapoint/t1-618041acd6a98270c7905e6b6e15b84d.png";